<template>
    <DxDataGrid :hover-state-enabled="true" :show-borders="false" :data-source="props.data" id="rateGridContainer"
        :selected-row-keys="selectedKeys" :auto-navigate-to-focused-row="true" key-expr="id" @content-ready="onContentReady">
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />
        <DxStateStoring :enabled="true" type="localStorage" storage-key="rateGridContainer" />
        <DxColumn data-field="id" data-type="string" caption="ID" :visible="false" />
        <DxColumn data-field="name" data-type="string" caption="Name" width="150" />
        <DxColumn data-field="description" data-type="string" caption="Description" width="215" />
        <DxColumn data-field="value" data-type="number" caption="Value" width="100" />
        <DxColumn data-field="currency" data-type="string" caption="Currency" width="100" />
        <!-- <DxColumn data-field="active" data-type="boolean" caption="Is Used" title="Means that there are ay least on user currently using this rate." width="95"/> -->
        <DxColumn data-field="disabled" :calculate-cell-value="row => !row.disabled" data-type="boolean" caption="Active" width="95"/> 
        <DxColumn type="buttons" caption="Actions" :width="80">
            <DxButton hint="Edit rate" icon="edit" styling-mode="contained" type="normal" @click="edit" />
            <DxButton hint="Delete rate" icon="trash" styling-mode="contained" type="normal" @click="deleteRate" />
        </DxColumn>
        
        <DxPaging :page-size="10" />
        <DxPager :show-page-size-selector="true" :allowed-page-sizes="[5, 10, 20]" />
    </DxDataGrid>
</template>
  
<script setup lang="ts">
import { configureDataGridColumnsOrder } from "@/common/util";
import { RateItem } from "@/services/entities/RateItem";
import DxDataGrid, {
    DxColumn,
    DxFilterRow,
    DxPaging, DxPager,
    DxStateStoring,
    DxHeaderFilter,
    DxButton
} from "devextreme-vue/data-grid";
import { ref } from "vue";

const emit = defineEmits(["edit", "delete"]);
const selectedKeys = ref([] as number[]);
let isConfigured = false;

function  onContentReady(e: any) {
  // ensure default column order
  const defaultOrder = ['name', 'description', 'value', 'currency', 'disabled' , 'buttons'];
  if (!isConfigured) {
    configureDataGridColumnsOrder(e, defaultOrder);
    isConfigured = true;
  }
};

const props = defineProps({
    data: { Type: [] as RateItem[], default: [] as RateItem[] },
});

function edit(item: any) {
    selectedKeys.value = [item.row.data.id];
    emit("edit", item.row.data.id);
}

function deleteRate(item: any) {
    emit("delete", item.row.data.id);
}
</script>
  
<style scoped lang="scss">
.buttons {
    margin-bottom: 10px;

    b {
        margin-right: 3px;
    }
}
</style>
  